import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LOGO, HERO_IMG } from "@/lib/config";

export default function AdminLogin() {
  const { user, signIn } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) nav("/admin", { replace: true }); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/login", f);
      signIn(data);
      nav("/admin");
    } catch (e2) {
      setErr(formatErr(e2));
    } finally {
      setBusy(false);
    }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0A0A0C] text-white" data-testid="admin-login-page">
      <div className="relative hidden lg:block">
        <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0A0A0C]" />
        <div className="absolute inset-0 speed-lines opacity-30" />
      </div>
      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-white mb-10" data-testid="admin-login-back"><ArrowLeft size={16} /> Torna al sito</Link>
          <img src={LOGO} alt="TMS Garage" className="h-20 mb-8" />
          <p className="eyebrow mb-2">Solo titolare</p>
          <h1 className="tms-title text-5xl mb-8">Area <span className="font-script normal-case text-red-500">riservata</span></h1>
          <form onSubmit={submit} className="space-y-4">
            <input type="email" className="tms-input" placeholder="Email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="admin-login-email" />
            <input type="password" className="tms-input" placeholder="Password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="admin-login-password" />
            {err && <p className="text-sm text-red-500" data-testid="admin-login-error">{err}</p>}
            <button className="btn-red w-full" disabled={busy} data-testid="admin-login-submit">{busy ? "Accesso…" : "Accedi"}</button>
          </form>
          <div className="flex items-center gap-3 my-6 text-xs text-zinc-600"><span className="flex-1 h-px bg-zinc-800" />oppure<span className="flex-1 h-px bg-zinc-800" /></div>
          <button onClick={google} className="w-full border border-zinc-700 hover:border-white py-3 text-sm font-semibold flex items-center justify-center gap-3 transition-colors" data-testid="admin-login-google">
            <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>
            Accedi con Google
          </button>
        </div>
      </div>
    </div>
  );
}
